export default function CourseOutcomes({ course }) {
  const outcomes = course?.outcomes;

  return (
    <section className="relative overflow-hidden bg-[#8B1E3F] text-white">
      {/* subtle architectural decoration */}
      <div
        aria-hidden="true"
        className="absolute inset-y-0 left-[38%] hidden w-px bg-white/10 xl:block"
      />

      <div
        aria-hidden="true"
        className="absolute -bottom-[220px] -left-[220px] h-[500px] w-[500px] rounded-full border border-white/[0.06]"
      />

      <div className="container relative z-[1] mx-auto">
        <div className="grid lg:grid-cols-[0.78fr_1.22fr]">

          {/* =====================================================
              LEFT — GRADUATE PROFILE
          ====================================================== */}

          <div className="relative flex flex-col justify-between border-white/15 py-20 lg:min-h-[760px] lg:border-r lg:py-24 lg:pr-16 xl:pr-20">

            <div>
              <span className="text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                Course Outcome
              </span>

              <h2 className="mt-7 max-w-[520px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(44px,5vw,72px)] font-normal leading-[1.02] tracking-[-0.04em]">
                What will you
                <span className="block text-[#D5AD57]">
                  become capable of?
                </span>
              </h2>

              <p className="mt-8 max-w-[480px] text-base leading-8 text-white/65">
                Completing{" "}
                <strong className="font-medium text-white">
                  {course?.title || "this programme"}
                </strong>{" "}
                is about more than earning a qualification. It is about
                developing the knowledge, judgement and professional
                capabilities to move confidently towards your next
                opportunity.
              </p>
            </div>

            {/* transformation statement */}

            <div className="mt-14 lg:mt-20">
              <div className="mb-6 h-px w-16 bg-[#D5AD57]" />

              <p className="max-w-[430px] font-['Libre_Caslon_Display',Georgia,serif] text-[27px] font-normal leading-[1.45] text-white/90">
                From understanding concepts
                <span className="text-[#D5AD57]"> to applying them with purpose.</span>
              </p>

              <div className="mt-8 flex items-center gap-5">
                <span className="grid h-14 w-14 place-items-center rounded-full border border-white/20 text-xl text-[#D5AD57]">
                  ↗
                </span>

                <div>
                  <strong className="block text-sm font-bold uppercase tracking-[0.13em]">
                    Graduate Profile
                  </strong>

                  <span className="mt-1 block text-sm text-white/50">
                    Knowledge · Ability · Confidence
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* =====================================================
              RIGHT — OUTCOME JOURNEY
          ====================================================== */}

          <div className="py-20 lg:py-24 lg:pl-16 xl:pl-20">

            {/* intro */}

            <div className="flex flex-col gap-6 border-b border-white/15 pb-10 sm:flex-row sm:items-end sm:justify-between">
              <div>
                <span className="text-xs font-bold uppercase tracking-[0.18em] text-white/45">
                  By the end of the programme
                </span>

                <h3 className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-[32px] font-normal sm:text-[38px]">
                  You should be able to...
                </h3>
              </div>

              <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[52px] font-normal leading-none text-[#D5AD57]">
                {String(outcomes.length).padStart(2, "0")}
              </span>
            </div>

            {/* outcomes */}

            <div className="relative mt-3">

              {/* continuous gold rail */}
              <span
                aria-hidden="true"
                className="absolute bottom-8 left-[19px] top-8 w-px bg-[#D5AD57]/35"
              />

              {outcomes.map((outcome, index) => (
                <div
                  key={outcome.title}
                  className="group relative grid grid-cols-[40px_1fr] gap-6 border-b border-white/10 py-8 sm:gap-8 sm:py-9"
                >

                  {/* node */}

                  <div className="relative z-[2] pt-1">
                    <span
                      className="
                        grid
                        h-10
                        w-10
                        place-items-center
                        rounded-full
                        border
                        border-[#D5AD57]/50
                        bg-[#8B1E3F]
                        text-xs
                        font-bold
                        text-[#D5AD57]
                        transition-all
                        duration-300
                        group-hover:bg-[#D5AD57]
                        group-hover:text-[#071A2F]
                      "
                    >
                      {index + 1}
                    </span>
                  </div>

                  {/* text */}

                  <div className="sm:grid sm:grid-cols-[0.75fr_1.25fr] sm:gap-10">
                    <h4 className="font-['Libre_Caslon_Display',Georgia,serif] text-[25px] font-normal leading-[1.2] text-white sm:text-[27px]">
                      {outcome.title}
                    </h4>

                    <p className="mt-3 max-w-[480px] text-[15px] leading-7 text-white/55 sm:mt-0">
                      {outcome.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* final result */}

            <div className="mt-10 bg-[#721832] px-7 py-7 sm:px-9">
              <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <span className="text-xs font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                    The Result
                  </span>

                  <p className="mt-2 max-w-[520px] font-['Libre_Caslon_Display',Georgia,serif] text-[24px] leading-[1.35]">
                    A graduate prepared to turn academic learning into
                    meaningful professional action.
                  </p>
                </div>

                <span className="hidden h-14 w-14 shrink-0 place-items-center rounded-full border border-[#D5AD57]/40 text-xl text-[#D5AD57] sm:grid">
                  ✓
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}